var _path, _path2, _circle, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStariconnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 12.25L23.7626 16.57L28.4201 16.915L24.8501 19.93L25.9676 24.46L22.0001 22L18.0326 24.46L19.1501 19.93L15.5801 16.915L20.2376 16.57L22.0001 12.25Z",
    fill: "#A24FD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 12.25L20.2376 16.57L15.5801 16.915L19.1501 19.93L18.0326 24.46L22.0001 22M22.0001 12.25L23.7626 16.57L28.4201 16.915L24.8501 19.93L25.9676 24.46L22.0001 22",
    stroke: "#A24FD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18.5,
    r: 16,
    stroke: "#D7CEDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 0.75L39.995 2.005L41.25 2.5L39.995 2.995L39.5 4.25L39.005 2.995L37.75 2.5L39.005 2.005L39.5 0.75Z",
    fill: "#A24FD8",
    stroke: "#A24FD8",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_158_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30.75L2.995 32.005L4.25 32.5L2.995 32.995L2.5 34.25L2.005 32.995L0.75 32.5L2.005 32.005L2.5 30.75Z",
    fill: "#A24FD8",
    stroke: "#A24FD8",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_158_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5002 6.44995L42.7972 7.20295L43.5502 7.49995L42.7972 7.79695L42.5002 8.54995L42.2032 7.79695L41.4502 7.49995L42.2032 7.20295L42.5002 6.44995Z",
    fill: "#A24FD8",
    stroke: "#A24FD8",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_158_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(0 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_158_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    fill: "white",
    transform: "translate(41 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStariconnew);
export default __webpack_public_path__ + "static/media/stariconnew.330dad93c3e406f07f80ae20c7d979db.svg";
export { ForwardRef as ReactComponent };